import { render, staticRenderFns } from "./RedemptionRules.vue?vue&type=template&id=25584fec&scoped=true&"
import script from "./RedemptionRules.vue?vue&type=script&lang=ts&"
export * from "./RedemptionRules.vue?vue&type=script&lang=ts&"
import style0 from "./RedemptionRules.vue?vue&type=style&index=0&id=25584fec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25584fec",
  null
  
)

export default component.exports